<div class="scope-row-header flex items-center align-middle">
  <div
    class="column level-{{ level }}"
    [ngClass]="config?.componentMainColumnClass">
    <span>SECTION</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected"></div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
    <span>Start date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
    <span>End date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected"></div>
  <div class="column one--column">
    <span isEllipsisActive>3rd party cost</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    {{ 'scope_mark' | lang }} hours
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />total</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_HOURS?.selected">
    <span isEllipsisActive>{{ 'agency' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.UNIT_PRICE?.selected">
    <span isEllipsisActive>Rate</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
    <span
      isEllipsisActive
      *ngIf="!config?.scopeVersion.identity.costPlus">
      {{ 'agency' | lang }} <br />
      total
    </span>
    <span
      isEllipsisActive
      *ngIf="config?.scopeVersion.identity.costPlus">
      Cost plus <br />
      total
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.showActionsColumn"></div>
</div>
